import {Injectable} from '@angular/core';
import {TisaUmpireHttpService} from '../tisa-umpire-http.service';
import {
  CrudService,
  deserialize,
  JsonApiParams,
  JsonApiResponse,
  objectToHttpParams,
} from '@tisa-group/cdk';
import {Observable} from 'rxjs';
import {UmpireLineups} from '@tisa-group/models';

@Injectable()
export class LineupService implements CrudService<UmpireLineups> {
  constructor(readonly http: TisaUmpireHttpService) {}

  fetch(
    matchesFetchIdentifier: string,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireLineups>> {
    return this.http
      .get(`/matches/${matchesFetchIdentifier}?include=lineups`, {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }
}
